import CategoryPageView from "@/components/feature/CategoryPageView";

export default function LifestylePage() {
  return <CategoryPageView categoryKey="lifestyle" />;
}